export default __webpack_public_path__ + "static/media/filled_comment.b86d5453.svg";